/**
 * Distingue une session réellement invalide (jeton révoqué / refresh token
 * inconnu) d'une panne passagère (réseau coupé, timeout, 5xx après un déploiement).
 *
 * Règle : on ne déconnecte l'utilisateur QUE sur une erreur définitive.
 * Toute erreur transitoire conserve la session — sinon une simple coupure
 * réseau ou un redémarrage serveur déconnecte tout le monde.
 */

const DEFINITIVE_CODES = [
  "refresh_token_not_found",
  "refresh_token_already_used",
  "invalid_grant",
  "invalid_refresh_token",
  "session_not_found",
  "user_not_found",
  "bad_jwt",
];

const DEFINITIVE_MESSAGES = [
  "refresh token not found",
  "invalid refresh token",
  "refresh_token_not_found",
  "invalid grant",
  "session not found",
  "user from sub claim in jwt does not exist",
  "jwt expired",
];

interface AuthErrorLike {
  message?: string;
  status?: number;
  code?: string;
  name?: string;
}

export function isDefinitiveAuthError(error: unknown): boolean {
  if (!error) return false;

  const err = error as AuthErrorLike;
  const code = (err.code || "").toLowerCase();
  if (DEFINITIVE_CODES.includes(code)) return true;

  const message = (err.message || "").toLowerCase();
  if (!message) return false;

  // Erreurs réseau : jamais définitives.
  if (
    message.includes("failed to fetch") ||
    message.includes("network") ||
    message.includes("timeout") ||
    message.includes("aborted") ||
    message.includes("load failed")
  ) {
    return false;
  }

  if (DEFINITIVE_MESSAGES.some((m) => message.includes(m))) return true;

  // Un 400/401 explicite d'auth est définitif ; 5xx et 0 ne le sont pas.
  return err.status === 400 || err.status === 401;
}
